import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Loading from '../components/common/Loading';

const COMPLETE_PHOTO_PATH = '/admin/completar-cadastro';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading text="Verificando autenticação..." />
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Bloqueia acesso enquanto o usuário não tiver foto cadastrada
  if (user && !user.photo_url && location.pathname !== COMPLETE_PHOTO_PATH) {
    return <Navigate to={COMPLETE_PHOTO_PATH} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default PrivateRoute;
